import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-start gap-4" }
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = { class: "mb-1.5 flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "text-[10px] font-bold uppercase tracking-wider text-[#737373]" }
const _hoisted_5 = { class: "text-sm font-semibold text-[#242B59]" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2.5 flex items-start gap-1.5 text-xs leading-relaxed text-[#626468]"
}

import { ExclamationCircleIcon, InformationCircleIcon, XIcon } from '@heroicons/vue/solid';

type ValidationType =
    | 'OUT_OF_SCOPE'
    | 'INVALID_INTENT'
    | 'AGENT_NAME_AMBIGUOUS'
    | 'INPUT_TOO_SHORT'
    | 'NO_SEMANTIC_CONTENT';

interface Props {
    errorType: ValidationType;
    message: string;
    suggestion?: string;
    dismissible?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraValidationMessage',
  props: {
    errorType: {},
    message: {},
    suggestion: { default: '' },
    dismissible: { type: Boolean, default: false }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isWarning = (type: ValidationType) => type !== 'NO_SEMANTIC_CONTENT';

const labelByType: Record<ValidationType, string> = {
    OUT_OF_SCOPE: 'Fora de Escopo',
    INVALID_INTENT: 'Entrada Inválida',
    AGENT_NAME_AMBIGUOUS: 'Filtro Ambíguo',
    INPUT_TOO_SHORT: 'Entrada Curta',
    NO_SEMANTIC_CONTENT: 'Não Compreendido',
};

const iconByType: Record<ValidationType, typeof ExclamationCircleIcon> = {
    OUT_OF_SCOPE: ExclamationCircleIcon,
    INVALID_INTENT: InformationCircleIcon,
    AGENT_NAME_AMBIGUOUS: InformationCircleIcon,
    INPUT_TOO_SHORT: InformationCircleIcon,
    NO_SEMANTIC_CONTENT: ExclamationCircleIcon,
};

const dismiss = () => emit('dismiss');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-2xl border border-[#E5E7EB] bg-[#F8FAFC] px-5 py-4 shadow-[0px_1px_3px_rgba(0,0,0,0.05),0px_1px_2px_rgba(0,0,0,0.03)] transition-all", 
            isWarning(props.errorType)
                ? 'border-l-4 border-l-[#F59E0B]'
                : 'border-l-4 border-l-[#EF4444]'
        ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-[#E5E7EB] bg-white shadow-sm", isWarning(props.errorType) ? 'text-[#D97706]' : 'text-[#DC2626]'])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(iconByType[props.errorType]), { class: "h-5 w-5" }))
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(labelByType[props.errorType]), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["rounded px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider shadow-sm", 
                            isWarning(props.errorType)
                                ? 'bg-[#FEF3C7] text-[#D97706]'
                                : 'bg-[#FEE2E2] text-[#DC2626]'
                        ])
          }, _toDisplayString(isWarning(props.errorType) ? 'atenção' : 'erro'), 3)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1),
        (_ctx.suggestion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("svg", {
                class: "mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-amber-500",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.suggestion), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.dismissible)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rounded-lg p-1 text-[#A3A3A3] transition-colors hover:bg-black/5",
            onClick: dismiss
          }, [
            _createVNode(_unref(XIcon), { class: "h-5 w-5" })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})